// extracted by mini-css-extract-plugin
export var restrictedWidthButton = "_re-0";